import { testimonials } from "@/mocks/comicData";

const principles = [
  { icon: "ri-flashlight-line", title: "更新及时", desc: "最新章节与连载进度第一时间同步，今天有没有更新一眼便知。" },
  { icon: "ri-lock-line", title: "收藏追更", desc: "收藏后自动追更，新章节上线第一时间提醒，不再错过更新。" },
  { icon: "ri-community-line", title: "同好社区", desc: "汇聚热爱《天才医仙》的读者，一起追更、一起交流剧情。" },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-building-line"></i>关于本站
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一个专注的天才医仙追更站
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              本站以「让每一位读者不错过最新章节」为初心，专注整理《天才医仙》的更新进度、连载资讯与剧情资料，帮助你省去找章节、追进度的烦恼。
            </p>

            <div className="mt-7 grid gap-4 sm:grid-cols-3">
              {principles.map((p) => (
                <div key={p.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-medium text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-medium text-foreground-950">联系我们</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                遇到追更问题或有内容反馈，欢迎来信：<a href="mailto:contact@tiancaiyixian-manhua.com" className="text-primary-700 underline-offset-2 hover:underline">contact@tiancaiyixian-manhua.com</a>
              </p>
              <p className="mt-1.5 text-xs text-foreground-600">我们会在 1 个工作日内回复。</p>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">读者口碑</h3>
            <div className="mt-6 space-y-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex text-secondary-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">「{t.text}」</blockquote>
                  <figcaption className="mt-3 text-xs text-foreground-600">{t.name}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}